import styled from "styled-components";

export const PriorityFormContainer = styled.div`
  .footer-dialog-buttons {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  .line-buttons {
    display: flex;
    justify-content: space-between;
    width: 100%;
    position: relative;
    top: 16px;
    margin-right: 15px !important;
  }

  .informacoes-prioridade {
    margin-top: 15px;
  }

  .button-priority-tms-form {
    margin-right: 3px;
  }

  .send-button-wrapper {
    display: flex;
    align-items: center;
    gap: 8px;
    flex: 1;
  }

  .line-buttons > .button-priority-tms-form {
    flex: 1;
  }

  .send-button-wrapper > .button-priority-tms-form {
    width: 100%;
  }

  .send-button-spinner {
    color: var(--color-action-default) !important;
  }

  div[class="row"] {
    padding-top: 5px !important;
  }
`;
